import { Button } from "react-bootstrap";
import { useAppDispatch } from "../../redux/store";
import { useHandleDoorLockStateMutation } from "../../services/bClientApi";
import { showError, showSuccess } from "../../redux/counter/counterSlice";
import canAccess from "../../services/accessService/accessService";

interface RemoteLockPayload {
  deviceId?: string;
  deviceName?: string;
  deviceType?: string;
}

interface RemoteLockControlsProps {
  remoteLockPayload: RemoteLockPayload;
}

export default function RemoteLockControls({ remoteLockPayload }: RemoteLockControlsProps) {
  const [
    handleDoorState,
    {
      isLoading: handleDoorStateLoading,
    }
  ] = useHandleDoorLockStateMutation();

  const dispatch = useAppDispatch();

  const handleRemoteLockDoorStateRequest = async (action: 'lock' | 'unlock') => {
    const doorId = remoteLockPayload.deviceId;
    if (!doorId) {
      return;
    }
    const doorResponse = await handleDoorState({
      doorId,
      action,
    }).unwrap();

    console.log('Door Response:', doorResponse);

    if (doorResponse.doorStateResult) {
      dispatch(showSuccess('Door Lock Updated'));
      return;
    }
    dispatch(showError('Door Lock Update Failed'));
  };

  if (!remoteLockPayload.deviceId) {
    return null;
  }

  return (
    <div>
      <b>Remote Lock</b> <br />
      <div className="mb-4">
        <div>
          Device ID: <a target="_blank" href={`https://connect.remotelock.com/devices/${remoteLockPayload.deviceType}/${remoteLockPayload.deviceId}`} rel="noreferrer">
            {remoteLockPayload.deviceId}
          </a>
        </div>
        <div>
          Device Name: {remoteLockPayload.deviceName}
        </div>
        <div>
          Device Type: {remoteLockPayload.deviceType}
        </div>
        {canAccess('property', 'door-controls') && (
          <div>
            <Button
              onClick={() => handleRemoteLockDoorStateRequest('lock')}
              disabled={handleDoorStateLoading}
              className={'me-2 mb-2'}
              variant={'danger'}
              size={'sm'}
            >
              Lock
            </Button>
            <Button
              onClick={() => handleRemoteLockDoorStateRequest('unlock')}
              disabled={handleDoorStateLoading}
              className={'me-2 mb-2'}
              variant={'success'}
              size={'sm'}
            >
              Unlock
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
